import React from 'react';

import cx from 'classnames';

import { AVATAR_COLOR_COUNT } from 'constants-channel';
import { getInitials, imageUrl } from 'lane-shared/helpers/formatters';

import styles from './HomeChannelPickerModal/HomeChannelPickerModal.scss';

function getAvatarColorIndex(name: string): number {
  let hash = 0;

  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  return Math.abs(hash) % AVATAR_COLOR_COUNT;
}

function getChannelInitials(name: string, isCompany: boolean): string {
  const words = name.split(' ').filter(word => /^[a-zA-Z0-9]/.test(word));

  return getInitials(words.join(' '), isCompany);
}

type ChannelAvatarProps = {
  name: string;
  logo?: string | null;
};

export function ChannelAvatar({ name, logo }: ChannelAvatarProps) {
  const colorClass = styles[`avatarColor${getAvatarColorIndex(name)}`];

  if (logo) {
    return (
      <div className={styles.avatar}>
        <img src={imageUrl(logo)} alt={name} className={styles.avatarImage} />
      </div>
    );
  }

  return (
    <div className={cx(styles.avatar, colorClass)}>
      {getChannelInitials(name, true)}
    </div>
  );
}
